(function() {

    'use strict';

    var ItxCheckboxCmp = {
        controllerAs: '$ctrl',
        templateUrl: 'checkboxCmpTpl.html',
        controller: ItxCheckboxCmpCtrl,
        bindings: {
            data: '<',
            form: '=',
            outputChange: '&'
        }
    };

    angular.module('itxApp.common')
        .component('itxCheckbox', ItxCheckboxCmp);

    ItxCheckboxCmpCtrl.$inject = [];

    function ItxCheckboxCmpCtrl() {

        this.checkboxChange = function() {
            this.outputChange({ data: this.data });
        };

        this.$onInit = function(){
            if(this.data){
                this.data.idRandom = _.uniqueId('checkbox_');
                // SET DEFAULT properties
                this.data.title = this.data.title || '';
                this.data.type = this.data.type || 'check';
            }
        };
                
    }

})();